/** 관제 자료실 — 시스템 설정 UI / API */

export interface ControlArchiveSettings {
  /** true일 때만 글·첨부 삭제 가능 (기본 끔) */
  allow_delete: boolean;
}

export const DEFAULT_CONTROL_ARCHIVE_SETTINGS: ControlArchiveSettings = {
  allow_delete: false,
};

export function mergeControlArchiveSettings(
  partial?: Partial<ControlArchiveSettings> | null
): ControlArchiveSettings {
  const p = partial || {};
  const d = DEFAULT_CONTROL_ARCHIVE_SETTINGS;
  const bool = (v: unknown, fallback: boolean) => {
    if (typeof v === 'boolean') return v;
    if (v === 'true' || v === '1') return true;
    if (v === 'false' || v === '0') return false;
    return fallback;
  };
  return {
    allow_delete: bool(p.allow_delete, d.allow_delete),
  };
}
